<div class="" data-aos="fade-up">
	<div class="section-details text-white">
		<div data-aos="fade-up" data-aos-duration="600" class="aos-init aos-animate">
			<video [id]="videoID" controls>
				<source src="" type="video/mp4">
			</video>
		</div>
	</div>    
</div>
